import { call, takeEvery, put } from 'redux-saga/effects';
import {
  dadataSearchBank,
  dadataSearchBankSuccess,
  dadataSearchBankFailure,
} from '../actions';

import { autoSearchRequestBank } from '../api';

function* dadataSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(autoSearchRequestBank, payload);
    if (response.data.suggestions.length) {
      yield put(dadataSearchBankSuccess(response.data.suggestions));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(dadataSearchBankFailure(error));
  }
}

export function* dadataBankWatcher() {
  yield takeEvery(dadataSearchBank.toString(), dadataSaga);
}
